// extracted by mini-css-extract-plugin
export default {"results":"Results_results__EWm0A","loading":"Results_loading__0Aziu","dmresults":"Results_dmresults__KSSpj","dmresultsContainer":"Results_dmresultsContainer__PCiEI"};